export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000/api";

export const API_PATHS = {
  AUTH: {
    LOGIN: "/auth/login",
    VERIFY_OTP: "/auth/login/verify-otp",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    PROFILE: "/auth/profile",
    SETUP: "/auth/setup",
    SETUP_STATUS: "/auth/setup-status",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
  },
  USER: {
    PROFILE: "/users/profile",
    UPDATE: "/users/update",
  },
  // Add other modules here
};

// QA-only tools (CMS test pushes). Build with "true" on UAT only.
export const TEST_TOOLS_ENABLED =
  process.env.REACT_APP_TEST_TOOLS_ENABLED === "true";

export const getApiPath = (path: string) => `${API_BASE_URL}${path}`;
